import axios from '../../config/axios-config';
import * as actionTypes from './allActionList';

/** Checking if already authenticated through localStorage **/
const startAuthListen = () => {
  return {
    type: actionTypes.START_AUTH_LISTEN,
  };
};

const authenticated = (verifiedData, isUploaded) => {
  return {
    type: actionTypes.AUTHENTICATED,
    verifiedData,
    isUploaded,
  };
};

const unauthenticated = (message) => {
  return {
    type: actionTypes.UNAUTHENTICATED,
    message,
  };
};

export const authListen = () => {
  return async (dispatch) => {
    dispatch(startAuthListen());
    try {
      const { data } = await axios.get('/users/me', {
        headers: { 'x-auth': localStorage.getItem('x-auth-token') },
      });

      if (data.statusCode) {
        dispatch(unauthenticated(data.message));
      } else {
        dispatch(authenticated(data.user, data.avatar));
      }
    } catch (e) {
      localStorage.removeItem('x-auth-token');
      dispatch(unauthenticated('server.unexpected-error'));
    }
  };
};
/************************************************************/

/** Sign Up Action Creators **/
const startSignUpCall = () => {
  return {
    type: actionTypes.START_SIGN_UP_CALL,
  };
};

const successSigningUp = (verifiedData) => {
  return {
    type: actionTypes.SUCCESS_SIGNING_UP,
    verifiedData,
  };
};

const failedSigningUp = (errorMessage) => {
  return {
    type: actionTypes.FAILED_SIGNING_UP,
    errorMessage,
  };
};

// export const registerAccount = (data) => {
//   return async (dispatch) => {
//     dispatch(startSignUpCall());
//     console.log(data);
//     await axios
//       .post(`/signup/${data.user_type}`, data)
//       .then((response) => {
//         localStorage.setItem('x-auth-token', response.headers['x-auth']);
//         dispatch(successSigningUp(response.data));
//       })
//       .catch((error) => {
//         dispatch(failedSigningUp(error.message));
//       });
//   };
// };

export const signUp = (email, password, confirmPassword, lang) => {
  return async (dispatch) => {
    dispatch(startSignUpCall());

    try {
      const { data, headers } = await axios.post('/signup', {
        email,
        password,
        confirmPassword,
        lang,
      });

      if (data.statusCode) {
        // Custom error instance
        dispatch(failedSigningUp(data.message));
      } else {
        localStorage.setItem('x-auth-token', headers['x-auth']);
        dispatch(successSigningUp(data));
      }
    } catch (e) {}
  };
};
/******************************/

/** Sign In Action Creators **/
const startSignInCall = () => {
  return {
    type: actionTypes.START_SIGN_IN_CALL,
  };
};

const successSigningIn = (verifiedData, isUploaded) => {
  return {
    type: actionTypes.SUCCESS_SIGNING_IN,
    verifiedData,
    isUploaded,
  };
};

const failedSigningIn = (errorMessage) => {
  return {
    type: actionTypes.FAILED_SIGNING_IN,
    errorMessage,
  };
};

// export const signIn = (data) => {
//   return async (dispatch) => {
//     dispatch(startSignInCall());
//     try {
//       const reusables = await axios.post('/login/reusables', data);
//
//       if (reusables.data.statusCode === 400) throw new Error(reusables.data.message);
//       else if (reusables.data.statusCode === 403) return dispatch(failedSigningIn('403'));
//
//       localStorage.setItem('x-auth-token', reusables.headers['x-auth']);
//       const avatar = await axios.get(`/users/${reusables.data._id}/avatar`);
//       let isUploaded = true;
//
//       if (avatar.data.code === -1) isUploaded = false;
//
//       dispatch(successSigningIn(reusables.data, isUploaded));
//     } catch (e) {
//       dispatch(failedSigningIn(e.message));
//     }
//   };
// };

export const login = (email, password) => {
  return async (dispatch) => {
    dispatch(startSignInCall());
    try {
      const { data, headers } = await axios.post('/login', {
        email,
        password,
      });

      if (data.statusCode) {
        dispatch(failedSigningIn(data.message));
      } else {
        localStorage.setItem('x-auth-token', headers['x-auth']);
        dispatch(successSigningIn(data.user, data.avatar));
      }
    } catch (e) {}
  };
};
/*****************************/

const startLogout = () => {
  return {
    type: actionTypes.START_LOGOUT,
  };
};

/** Sign Out Action Creators **/
const successLogout = () => {
  return {
    type: actionTypes.SUCCESS_LOGOUT,
    verifiedData: null,
  };
};

const failedLogout = () => {
  return {
    type: actionTypes.FAILED_LOGOUT,
  };
};

export const logout = () => {
  return async (dispatch) => {
    dispatch(startLogout());
    try {
      await axios.delete('/users/me/token', {
        headers: {
          'x-auth': localStorage.getItem('x-auth-token'),
        },
      });
      localStorage.removeItem('x-auth-token');
      dispatch(successLogout());
    } catch (e) {
      dispatch(failedLogout());
    }
  };
};
/******************************/
